/**
 * @generated SignedSource<<0e64b69d819325735f066849d1b51400>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CityWalkCompleteDialog_cityWalk",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CityWalkContribution",
      "kind": "LinkedField",
      "name": "activeContribution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IntlMessage",
      "kind": "LinkedField",
      "name": "customIntlMessages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "identifier",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CityWalk",
  "abstractKey": null
};

node.hash = "3a7ab4d457f85abb16733bde935487b5";

module.exports = node;
